import { Accordion, Divider, Flex, Image, Text } from '@mantine/core';
import type { FC } from 'react';
import { FAQ } from '../../services/faq/faq.schema';
import AnswerText from './AnswerText';
import QuestionButton from './QuestionButton';
import QuestionText from './QuestionText';
import { faqAddIcon, faqRemoveIcon } from '../../assets';

type Props = {
  faq: FAQ;
  index: number;
  currentlySelectedAccordion: string | null;
};

const FaqAccordionItem: FC<Props> = ({ faq, index, currentlySelectedAccordion }) => {
  return (
    <Accordion.Item value={faq.question}>
      <Accordion.Control p={0}>
        <Flex justify='space-between'>
          <Flex gap={8} justify='center' align='center'>
            <QuestionButton buttonText={`Q${index + 1}`} />
            <QuestionText questionText={faq.question} />
          </Flex>

          <Image
            width={32}
            height={32}
            withPlaceholder
            src={currentlySelectedAccordion === faq.question ? faqRemoveIcon : faqAddIcon}
            styles={(theme) => ({
              root: {
                width: 32,
                height: 32,
              },
            })}
          />
        </Flex>
      </Accordion.Control>
      <Divider mt={0} size='xs' color='#B6B6B6' />

      <Accordion.Panel>
        <AnswerText answerText={faq.answer} />
      </Accordion.Panel>
    </Accordion.Item>
  );
};

export default FaqAccordionItem;
